import { render, staticRenderFns } from "./PropertyFavourites.vue?vue&type=template&id=33bbda52&"
import script from "./PropertyFavourites.vue?vue&type=script&lang=ts&"
export * from "./PropertyFavourites.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports